﻿<template>
    <login_screen screen="forgot_password"></login_screen>
</template>

<script lang="ts" src="./forgot_password.ts"></script>